import React from "react";
import { useTranslation } from "react-i18next";
import { PageHero } from "../components/PageHero";
import { StepFlow, CTASection } from "../components/Sections";
import { Reveal, Overline } from "../components/Reveal";
import { IMAGES } from "../data/config";

const CITIES = ["Dubai", "Singapore", "Limassol", "Lisbon", "Bangkok", "Miami", "Panama", "London"];

export default function TradersConferences() {
  const { t } = useTranslation();
  return (
    <>
      <PageHero
        overline={t("traders.overline")}
        title={<>{t("traders.titleA")} <span className="text-gradient-gold">{t("traders.titleAccent")}</span></>}
        subtitle={t("traders.subtitle")}
        image={IMAGES.conference}
        accent="gold"
        testId="traders-hero"
      />

      <section className="py-16 border-t border-white/5">
        <div className="container-x">
          <Reveal>
            <Overline color="gold">{t("traders.circuitOverline")}</Overline>
            <div className="mt-6 flex flex-wrap gap-3">
              {CITIES.map((c) => (
                <span key={c} className="px-4 py-2 rounded-md bg-navy-800 border border-white/10 font-mono text-sm text-white/75" data-testid={`circuit-${c}`}>{c}</span>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      <StepFlow overline={t("traders.flowOverline")} title={t("traders.flowTitle")} accent="gold" steps={t("traders.steps", { returnObjects: true })} />
      <CTASection title={t("traders.ctaTitle")} subtitle={t("traders.ctaSub")} ctaLabel={t("traders.ctaLabel")} ctaTo="/quote?plan=trader&cycle=E" variant="gold" testId="traders-cta" />
    </>
  );
}
